"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const expired_1 = __importDefault(require("@cart/expired"));
const provider_1 = require("@cart/provider");
const react_1 = require("react");
const mixpanel_1 = require("../utils/mixpanel");
const ExpiredCartError = ({ open, onClose, data, isHardChoice, onRouting, i18n, track }) => {
    (0, react_1.useEffect)(() => {
        if (open)
            track(...(0, mixpanel_1.ExpiredCartRender)());
    }, [open]);
    const { recoverCartConnected, cancelRecoverCartConnected } = (0, provider_1.useCartActions)();
    const handleRecover = (dismissed) => recoverCartConnected(dismissed).finally(onClose);
    const handleCancelRecover = () => cancelRecoverCartConnected().finally(onClose);
    const { recoverable_items: items } = data;
    return ((0, jsx_runtime_1.jsx)(expired_1.default, { open: open, onClose: onClose, items: items, recover: handleRecover, cancelRecover: handleCancelRecover, isHardChoice: isHardChoice, onRouting: onRouting, i18n: i18n, track: track }));
};
exports.default = ExpiredCartError;
